import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: Cookies.get('Admin-Token') || '',
    name: Cookies.get('Admin-Name') || '',
    routes: [],
    routesLoaded: false
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      Cookies.set('Admin-Token', token)
    },
    SET_NAME(state, name) {
      state.name = name
      Cookies.set('Admin-Name', name)
    },
    SET_ROUTES(state, routes) {
      state.routes = routes
      state.routesLoaded = true
    },
    RESET_ROUTES(state) {
      state.routes = []
      state.routesLoaded = false
    },
    CLEAR_AUTH(state) {
      state.token = ''
      state.name = ''
      state.routes = []
      state.routesLoaded = false
      Cookies.remove('Admin-Token')
      Cookies.remove('Admin-Name')
    }
  }
})
